import { Box, withStyles } from '@material-ui/core';

export const ContainerBox = withStyles({})(Box);
